import { combineReducers } from 'redux';

import externalCrmMilestones from './externalCrmMilestones.reducer';
import milestoneDefinitionsCollection from './milestoneDefinitions.reducer';
import milestoneDefinitionsSchema from './milestoneDefinitionsSchema.reducer';
import milestonePresentationSettings from './milestonePresentationSettings.reducer';

const reducer = combineReducers({
  externalCrmMilestones,
  milestoneDefinitionsCollection,
  milestoneDefinitionsSchema,
  milestonePresentationSettings,
});

export default reducer;
